/**
 * @file 菜单配置项
 * 路由规则和菜单项无法复用。路由匹配的顺序和菜单顺序对不上
 *
 *
 */

import { compact } from 'lodash-es'
import { Icon } from '@/components/Icon'

import Permission from '@/services/permission'
import { personalMenuConfig } from './personalMenuConfig'
import { otherMenuConfig } from './otherMenuConfig'

export interface IMenuConfig {
  icon?: any;
  name: string;
  path: string;
  children?: IMenuConfig[];
  // 菜单的后面增加分割线
  hasAfterDivider?: boolean;
  type?: 'divider';
  // 菜单项需要的权限列表，为且的关系
  permissions: string[];
}

// 渲染菜单图标的方法
export function renderMenuIcon(iconName: string) {
  return (
    <span role='img' className='anticon'>
      <Icon iconName={iconName} size='large' color={'#D9D9D9'}/>
    </span>
  )
}

// 过滤没有权限的模块
function filterMenuConfig(config) {
  return compact(config.map((item) => {
    if (Permission.inst.checkModulesPermission(item.permissions)) {
      if (item.children) {
        item.children = filterMenuConfig(item.children)
      }
      return item
    }
    return undefined
  }))
}

let resultCache

export default async function getMenuConfig() {
  await Permission.promise

  if (!resultCache) {
    resultCache = filterMenuConfig(IS_PERSONAL_VERSION ? personalMenuConfig() : otherMenuConfig())
  }

  return resultCache
}
